export function normalizeSelectionName(name: string): string {
  return name.replace(/\s*\([^)]*\)\s*$/, '').trim();
}

export interface FavouriteInfo {
  isFavourite: boolean;
  isJointFavourite: boolean;
  label: 'Favourite' | 'Joint favourite' | null;
}

export function getFavouriteInfo(
  selectionName: string,
  runners: Array<{ horse_name: string; bet365_decimal_odds?: string | null }>
): FavouriteInfo {
  const normalizedSelection = normalizeSelectionName(selectionName);

  const validRunnersWithOdds = runners
    .map(runner => {
      const odds = parseFloat(runner.bet365_decimal_odds || '');
      return Number.isFinite(odds) && odds > 0 ? { runner, odds } : null;
    })
    .filter((x): x is { runner: { horse_name: string }; odds: number } => x !== null);

  const favouriteOdds =
    validRunnersWithOdds.length > 0 ? Math.min(...validRunnersWithOdds.map(x => x.odds)) : null;

  const favouriteRunners =
    favouriteOdds === null
      ? []
      : validRunnersWithOdds.filter(x => x.odds === favouriteOdds).map(x => x.runner);

  const isFavourite =
    favouriteRunners.length > 0 &&
    favouriteRunners.some(r => normalizeSelectionName(r.horse_name) === normalizedSelection);

  const isJointFavourite = isFavourite && favouriteRunners.length > 1;
  const label = isFavourite ? (isJointFavourite ? 'Joint favourite' : 'Favourite') : null;

  return { isFavourite, isJointFavourite, label };
}
